import { ArrowClockwise } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

interface RefreshButtonProps {
  onRefresh: () => void
  refreshing?: boolean
  labelKey?: string
}

/**
 * Desktop (>=768 px) refresh control. Mobile layouts deliberately render no
 * button: D-053 requires the pull gesture there and forbids hidden or
 * duplicate refresh affordances.
 */
export function RefreshButton({
  onRefresh,
  refreshing = false,
  labelKey = 'profileSocial.refresh.action',
}: RefreshButtonProps) {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      className="grid size-11 place-items-center rounded-full border border-line bg-white text-teal hover:bg-mint disabled:opacity-50"
      onClick={onRefresh}
      disabled={refreshing}
      aria-label={t(labelKey)}
      aria-busy={refreshing}
    >
      {refreshing ? (
        <span className="skeleton skeleton--inline" aria-hidden="true" />
      ) : (
        <ArrowClockwise size={18} weight="bold" aria-hidden="true" />
      )}
    </button>
  )
}
